export default "__VITE_ASSET__CI095sv___"